import styled, { keyframes } from 'styled-components'
import { pxToRem } from 'styles/functions'

const fadeInDown = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, -20%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

const getHeaderHeight = (theme) => {
  const { header_height, logo_height } = theme

  if (theme) {
    return header_height || logo_height + 41 || 0
  }
}

const getHeight = (theme) => {
  const footerHeight = 142
  const msjLogoHeight = 86
  return (getHeaderHeight(theme) || msjLogoHeight) + footerHeight
}

interface StyledOverlayProps {
  theme: any;
  $isVisible: boolean;
}
export const StyledOverlay = styled.div<StyledOverlayProps>`
  ${({ $isVisible }) => !$isVisible && 'display: none;'}
  width: 100%;
  min-height: 100vh;
  position: absolute;
  top: ${({ theme }) => pxToRem(getHeaderHeight(theme))};
  left: 0;
  opacity: 1;
  background-color: ${({ theme }) => theme.card_background_color || 'white'};
  overflow: hidden;
  z-index: 1;
  animation: ${fadeInDown} 0.5s ease-in;
`

interface StyledContentProps {
  theme: any;
}
export const StyledContent = styled.div<StyledContentProps>`
  position: relative;
  padding: ${({ theme }) => pxToRem(theme.modal_padding || 20)};
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  input {
    margin: 0 !important;
  }
`

interface StyledCloseButtonProps {
  $themeCustom: any;
}
export const StyledCloseButton = styled.div<StyledCloseButtonProps>`
  background-color: ${({$themeCustom}) => $themeCustom ? $themeCustom.details.buttons.color : '#34b076' };
  border-radius: 50%;
  cursor: pointer;
  padding: 10px;
  transition: all 0.2s ease-in;
  align-self: start;
  margin-bottom: ${pxToRem(20)};

  img {
    width: 30px;
    height: 30px;
  }

  &:hover {
    background-color: #278f5b;
  }
`
